import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { JpgOrPngConversionResponse } from '../../../../../../../shared/models/JpgOrPngConversionResponse';
import { AlertService } from '../../../../../../../shared/services/alert.service';
import { ConversionService } from '../../../../../../../shared/services/conversion.service';
import { ProxyServiceFetchURLService } from '../../../../../../../shared/services/proxy-service-fetch-url.service';
import { PackService } from '../../../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { AiImageGenerationModel } from '../../models/ai-image-generation';
import { ImageResolutionModel, IMAGE_RESOLUTIONS } from '../../models/image-resolution';
import { AiService } from '../../services/ai.service';
import { ImageFormat } from '../../../gallery/icon-gallery/models/image-format';
import { IconGalleryService } from '../../../gallery/icon-gallery/services/iconGallery.service';
import { BlobService } from '../../../../../../../shared/services/blob.service';
import { syncBlobTokens } from '../../../../../../../shared/utils/blob-token-sync';

@Component({
  selector: 'app-image-generation',
    standalone:false,

  templateUrl: './image-generation.component.html',
  styleUrl: './image-generation.component.css'
})
export class ImageGenerationComponent implements OnInit {
  selectedImageIndex = 0;

  fileError: string | null = null;
  allowedExtensions: string[] = ['jpg', 'png',];

  imageResultionId!: number | undefined;
  imageResolutionsList: ImageResolutionModel[] = IMAGE_RESOLUTIONS;
  aiImageGenerationModel: AiImageGenerationModel = new AiImageGenerationModel();

  isLoading:boolean = false;

  conversionResponse : JpgOrPngConversionResponse = new JpgOrPngConversionResponse();
  downloadableFiles:string[]= [ImageFormat.Eps,ImageFormat.Svg];
  aiGeneratedImages:string[]=[];
  token!: string ;
  @ViewChild('aiImageGenerationForm') aiImageGenerationForm!: NgForm;

  isPngLoading:boolean=false;
  isSvgLoading:boolean=false;
  isEpsLoading:boolean=false;
  isJpgLoading:boolean=false;


  private readonly destroyRef = inject(DestroyRef);

  constructor(private aiService: AiService,
    private conversionService:ConversionService,
    private iconGalleryService:IconGalleryService,
    private alertService:AlertService,
    private blobService:BlobService,
    public proxyServiceFetchURLService:ProxyServiceFetchURLService,
    private packService:PackService,
    private cdr:ChangeDetectorRef) {
    syncBlobTokens({
      blobService: this.blobService,
      destroyRef: this.destroyRef,
      setToken: (t) => (this.token = t ?? ''),
      cdr: this.cdr,
    });
  }

 async ngOnInit() {
  await this.getblobToken();
  }

  async getblobToken() {
      this.token = await firstValueFrom(this.blobService.getBlobToken());
  }
  onSelect(event: Event): void {
    this.fileError = null;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const fileSizeMB = file.size / (1024*1024);
      if(fileSizeMB > 10){
        this.clearFile(input);
        this.fileError = 'File size exceeds 10MB. Please select a smaller file.';
        return;
      }
      if (fileExtension && this.allowedExtensions.includes(fileExtension)) {
        this.aiImageGenerationModel.reference_image = file ? file : null;
      } else {
        this.aiImageGenerationModel.reference_image = null;
        this.aiImageGenerationForm.resetForm(this.aiImageGenerationModel);
        this.fileError = `Invalid file type.Please select a valid file (${this.allowedExtensions.join(
          ','
        )}).`;
      }
    }
  }

  get isValidFile(): boolean {
    if (!this.aiImageGenerationModel.reference_image) {
      return false;
    }
    const fileName =
      this.aiImageGenerationModel.reference_image.name.toLowerCase();
    return fileName.endsWith(ImageFormat.Png.toString().toLowerCase()) || fileName.endsWith(ImageFormat.Jpg.toString().toLowerCase());
  }

  onClearDimension(evt: Event): void {
    this.imageResultionId = undefined;
    // this.aiImageGenerationModel.width = undefined;
    // this.aiImageGenerationModel.height = undefined;
  }

  clearFile(fileInput: HTMLInputElement): void {
    fileInput.value = '';
    this.aiImageGenerationModel.reference_image = null;
    this.fileError = null;
    this.imageResultionId = undefined;
  }

  async GenerateAiImage() {
    
    if (this.aiImageGenerationModel.reference_image) {
      const imageResolution = this.imageResolutionsList.find(
        (item: ImageResolutionModel) => item.id === this.imageResultionId
      );
      // this.aiImageGenerationModel.width = imageResolution?.width;
      // this.aiImageGenerationModel.height = imageResolution?.height;
    }
    this.isLoading = true;
    this.aiGeneratedImages = [];
    this.downloadableFiles = [ImageFormat.Eps,ImageFormat.Svg];
    this.fileError = null;
    await this.aiService
      .generateAiImages(this.aiImageGenerationModel)
      .subscribe({
        next: (data:string[]) => {
          if(data.length){

            let extension = this.getAiImageGeneratedFilesExtension(data);
            if(!this.downloadableFiles.includes(extension)){
              this.downloadableFiles.push(extension);
            }
          }
          this.aiGeneratedImages = data;
          this.isLoading=false;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);
        },
        error: (err) => {
          this.isLoading=false;
          this.alertService.errorNotification();
        },
      });
  }

  selectImage(index: number): void {
    this.selectedImageIndex = index;
  }

  getAiImageGeneratedFilesExtension(data:string[]):string{
    const extensions:Set<string> = new Set(
      data.map((url) => url.split('.').pop() || '')
    );
    return extensions.size > 0 ? [...extensions][0]! : '';
  }

  setLoadingState(format: ImageFormat, state: boolean): void {
    const key = `is${format.charAt(0).toUpperCase()}${format.slice(1)}Loading`;
    if(key in this){
      (this as any)[key] = state;
    }
  }

  getLoadingState(format: string): boolean {
    const key = `is${format.charAt(0).toUpperCase()}${format.slice(1).toLowerCase()}Loading`;
    return (this as any)[key] ?? false;
  }

  async downloadAiGeneratedImage(outputFile:string){

    this.setLoadingState(outputFile as ImageFormat, true);
    const filePath = this.aiGeneratedImages[this.selectedImageIndex];
   await this.conversionService.convertJpgOrPng(filePath, outputFile).subscribe({
      next: async(download:JpgOrPngConversionResponse) => {
        // await this.getblobToken();
        setTimeout(() => {
          this.setLoadingState(outputFile as ImageFormat, false);
          if (download?.converted_file) {
            this.iconGalleryService.triggerDownload('ai_image',download.converted_file, outputFile);
          }
          this.cdr.detectChanges();
        }, 500);
      }
      ,error: (err) => {
        this.setLoadingState(outputFile as ImageFormat, false);
        this.alertService.errorNotification();
      }});


  }


  ngOnDestroy(): void {


  }

}

